import {getColor} from "../utils";
import {nFormatter} from "./utils";

type LabelProps = {
    from: number,
    to: number,
    max: number
}
const Label = ({from, to, max}: LabelProps) => {
    const fromValue = Math.round(max * from);
    const toValue = Math.round(max * to);

    return (<>
            <i style={{backgroundColor: getColor(fromValue + .01 * max, max)}}/>
            {nFormatter(fromValue)}{nFormatter(toValue) ? ' - ' + nFormatter(toValue) : '+'}
        </>
    )
};

export {Label}